import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { URL } from '../config';
import { useNavigate } from 'react-router-dom';
import { change_product } from '../redux/slices/ProductSlice';
import { useDispatch } from 'react-redux';
import { MagnifyingGlass } from 'react-loader-spinner';




const Search = ({width}) => {
    const dispatch = useDispatch();
    const divRef =useRef(null);
    const [searchList,setSearchList]=useState(true);
    const [load,setLoad]=useState(false);
    const navigate = useNavigate();
const [products,setProducts]=useState();
const searchHandle=(value)=>{
    if(!value){
      setProducts(null)
      return;
    }
      setSearchList(true)
      setLoad(true)
    axios.post(`${URL}/api/home/search`,{
      q:value
    })
    .then(function (response) {
      if(response.data.success){
        setProducts(response.data.data.data) 
      }
      setLoad(false)
    })
    .catch(function (error) {
      console.log('error');
      setLoad(false)
    });
  }
  const product_select=(productSelect)=>{
    // dispatch(change_product(productSelect));
    navigate(`/product/${productSelect.id}`);
    
  }
  useEffect(()=>{

    const closeDrop= e =>{
      if(divRef.current===e.target.parentElement){
        setSearchList(true);
      }else{
        setSearchList(false)
      }
    }
      document.body.addEventListener('click', closeDrop);
      return () => {
        document.body.removeEventListener('click', closeDrop);
      };
  },[])
  return (
    <div className={`flex-grow-1 search ${width==='large'?'d-none d-md-flex':'d-md-flex'}`} ref={divRef}>
    {/* <input  onChange={(e)=>searchHandle(e.target.value)} 

       className=" form-control" style={{ border:'none' }}  placeholder='ادخل كلمة البحث' /> */}
    <i className="fa fa-search  bar" ></i>
    <input class=" dropdown-toggle" style={{ border:'none',outlineStyle: 'none', }}
    placeholder='ادخل كلمة البحث'
    onChange={(e)=>searchHandle(e.target.value)}  
     type="text"/>

    <ul >
        {load?(
            <div style={{ display:'flex',justifyContent:'center' }}>
    <MagnifyingGlass
         visible={true}
         height="60"
         width="60"
         ariaLabel="MagnifyingGlass-loading"
         wrapperStyle={{}}
         wrapperClass="MagnifyingGlass-wrapper"
         glassColor = '#29443a'
         color = 'white'
       />
            </div>
     
        ):(
            searchList&&products&&products.map((product)=>(
                <li onClick={()=>product_select(product)}><a href=''>{product.name}</a></li>
             ))

        )}      
    </ul>
  
  </div>
  )
}

export default Search